import { Channels } from '../../../common/channelsEnum';

type ChannelOptionLabels = {
  [channel in keyof typeof Channels]: {
    [labelKey: string]: string;
  };
};

export const CHANNEL_OPTION_LABELS: ChannelOptionLabels = {
  [Channels.EMAIL]: {
    enabled: 'Channel',
    'instant.enabled': 'Instant Delivery',
    'hourly.enabled': 'Hourly Delivery',
    'daily.enabled': 'Daily Delivery',
    'daily.hour': 'Daily Delivery: Hour',
    'weekly.enabled': 'Weekly Delivery',
    'weekly.hour': 'Weekly Delivery: Hour',
    'weekly.day': 'Weekly Delivery: Day',
    'monthly.enabled': 'Monthly Delivery',
    'monthly.hour': 'Monthly Delivery: Hour',
    'monthly.date': 'Monthly Delivery: Date',
    'off.enabled': 'Allow Unsubscribing',
    defaultDeliveryOption: 'Default Delivery Option'
  },
  [Channels.INAPP_WEB]: {
    enabled: 'Channel'
  },
  [Channels.PUSH]: {
    enabled: 'Channel'
  },
  [Channels.WEB_PUSH]: {
    enabled: 'Channel'
  },
  [Channels.SMS]: {
    enabled: 'Channel'
  },
  [Channels.CALL]: {
    enabled: 'Channel'
  }
};

export const WEEKLY_OPTIONS = [
  {
    label: 'Sunday',
    value: 'Sunday'
  },
  {
    label: 'Monday',
    value: 'Monday'
  },
  {
    label: 'Tuesday',
    value: 'Tuesday'
  },
  {
    label: 'Wednesday',
    value: 'Wednesday'
  },
  {
    label: 'Thursday',
    value: 'Thursday'
  },
  {
    label: 'Friday',
    value: 'Friday'
  },
  {
    label: 'Saturday',
    value: 'Saturday'
  }
];

export const MONTHLY_OPTIONS = [
  {
    label: 'On the first day',
    value: 'first'
  },
  {
    label: 'On the last day',
    value: 'last'
  }
];

const generateDailyHoursSelectOptions = () => {
  const options: { label: string; value: string }[] = [];

  for (let i = 0; i <= 23; i++) {
    const hour = i < 13 ? i : i - 12;
    const amPm = i < 12 ? 'am' : 'pm';

    const label = (hour === 0 ? '12' : hour.toString()).padStart(2, '0');
    const value = i.toString().padStart(2, '0');

    options.push({
      label: `${label}:00 ${amPm}`,
      value: `${value}:00`
    });
    options.push({
      label: `${label}:30 ${amPm}`,
      value: `${value}:30`
    });
  }

  return options;
};

export const HOUR_OPTIONS = generateDailyHoursSelectOptions();
